import React from 'react'
import Typography from 'material-ui/Typography'
import Paper from 'material-ui/Paper'
import Button from 'material-ui/Button'
import TextField from 'material-ui/TextField';
import { withStyles } from 'material-ui/styles'
import styles from './styles'

import { validateFormData } from '../../../common/formtool'
import InputPasswordField from '../../common/inputpassword';
class ResetPassword extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      errors: {},
      data: {
        oldpassword: "",
        newpassword: "",
        confpassword: ""
      },
      isChangePasswordBtnDisabled: true
    }
    this.onChange = this.onChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }
  handleSubmit() {
    let data = { ...this.state.data }
    let errors = validateFormData(data, {
      oldpassword: {
        required: this.props.translate('formfield_error_general_required')
      },
      newpassword: {
        required: this.props.translate('formfield_error_general_required')
      },
      confpassword: {
        required: this.props.translate('formfield_error_general_required')
      }
    })
    if (data.newpassword !== data.confpassword) {
      errors.confpassword = this.props.translate('profile_passwords_nomatch')
    }
    const missingFieldName = Object.keys(errors)[0]
    if (missingFieldName) {
      const textField = document.getElementsByName(missingFieldName)[0]
      textField && textField.focus()
    }
    if (Object.keys(errors).length) {
      this.setState({ errors: errors })
    } else {
      let self = this
      delete data.confpassword
      this.props.update(data).then(resp => {
        self.setState({
          data: {
            oldpassword: "",
            newpassword: "",
            confpassword: ""
          },
          isChangePasswordBtnDisabled: true
        })
      }).catch(err => {
        //
        if (err.errors === "error_incorrect_password") {
          self.setState({
            error: {
              type: 'error_incorrect_password'
            }
          })
        }

      })
    }
  }
  getUpdateError(error) {
    if (error.type === "error_incorrect_password") {
      return (
        <div className={this.props.classes.error}>
          <Typography type="subheading" color="inherit">
            {this.props.translate('profile_error_change_password')}
          </Typography>
        </div>
      )
    }
  }

  onChange(e) {
    let data = { ...this.state.data }
    data[e.target.name] = e.target.value
    let errors = { ...this.state.errors }
    errors = {
      ...errors,
      [e.target.name]: false
    }
    this.setState({ data, errors })
    let { isChangePasswordBtnDisabled } = this.state
    if (isChangePasswordBtnDisabled) {
      this.setState({ isChangePasswordBtnDisabled: false })
    }
  }
  render() {
    const {
      classes,
      translate,
      impersonating
    } = this.props

    const {
      data,
      error,
      errors,
      isChangePasswordBtnDisabled
    } = this.state

    return (
      <Paper className={classes.paper}>
        {error && this.getUpdateError(error)}
        <InputPasswordField
          classes={classes}
          error={errors.oldpassword ? true : false}
          name="oldpassword"
          label={translate("profile_oldpassword")}
          margin="normal"
          value={data.oldpassword}
          onChange={this.onChange}
          helperText={errors.oldpassword ? errors.oldpassword : translate("profile_oldpassword_help")}
          disabled={impersonating}
        />
        <InputPasswordField
          classes={classes}
          error={errors.newpassword ? true : false}
          name="newpassword"
          label={translate("profile_newpassword")}
          margin="normal"
          fullWidth
          value={data.newpassword}
          onChange={this.onChange}
          helperText={(errors.newpassword ? errors.newpassword : translate("profile_newpassword_help"))+ ' [ '+translate('password_helper_text')+' ] '}
          disabled={impersonating}
        />
        <InputPasswordField
          classes={classes}
          error={errors.confpassword ? true : false}
          name="confpassword"
          label={translate("profile_confpassword")}
          margin="normal"
          value={data.confpassword}
          onChange={this.onChange}
          helperText={(errors.confpassword ? errors.confpassword : translate("profile_confpassword_help"))+ ' [ '+translate('password_helper_text')+' ] '}
          disabled={impersonating}
        />
        <Button raised
          fullWidth
          color="accent"
          className={classes.button}
          type="submit"
          onClick={this.handleSubmit}
          disabled={isChangePasswordBtnDisabled || impersonating}
        >
          {translate("profile_change_password")}
        </Button>
      </Paper>
    )
  }
}

export default withStyles(styles)(ResetPassword)
